import React, { Component } from 'react';
import {
  Segment,
  Icon,
} from 'semantic-ui-react';
import { func } from 'prop-types';

// eslint-disable-next-line max-len
const termOfConsult = '<!doctype html><html lang="en"><head><meta charset="utf-8"></head><body><p>MOBILE HEALTH PTE LTD DOES NOT GIVE ANY WARRANTIES IN RESPECT TO MANADR SITES.</p><p>1.1    Manadr app user shall fully indemnify and hold harmless Mobile Health Pte Ltd and its affiliates, members, officers, employees and agents (collectively, the “Indemnitees”) from and against any claim, demand, loss, damage, cost, or liability (including without limitation reasonable legal fees) which any of the Indemnitees may suffer or suffers in connection with or arising from the use of Manadr app by Manadr app user.</p><p>1.2    To the maximum extent permitted by law, Mobile Health Pte Ltd and its Indemnitees, expressly:</p><p>(a)    disclaim and exclude all conditions, warranties and other terms which might otherwise be implied by statute, common law or the law of equity, including without limitation warranties of accuracy, reliability, merchantability, satisfaction, quality, fitness for a particular purpose; and</p><p>(b)    disclaim and exclude any and all liability for any loss, claim or damage (whether direct, indirect and/or consequential), regardless of the cause thereof, which Manadr app user may suffer in connection with using Manadr app, even if Manadr app user has been advised of the possibility thereof.</p></body></html>';

class PaymentTerm extends Component {
  render() {
    const { closeContextMenu } = this.props;
    return (
      <Segment.Group className="context-menu">
        <Segment className="menu-header">
          <Icon name="arrow left" size="large" onClick={closeContextMenu} />
          <span>Payment Term</span>
        </Segment>
        <Segment className="body">
          <div className="patient-info">
            <Segment basic dangerouslySetInnerHTML={{ __html: termOfConsult }} />
          </div>
        </Segment>
      </Segment.Group>
    );
  }
}
PaymentTerm.propTypes = {
  closeContextMenu: func.isRequired,
};


export default PaymentTerm;
